import { useEffect, useState, type RefObject } from 'react';

/**
 * One-way: once in view, never back. Not a `view()` timeline: the reveal is a one-time entrance
 * staggered with `animation-delay`, which a timeline ignores and would rewind on the way back up.
 * `false` on the server and the first client render, so hydration sees one answer.
 */
export function useInView(ref: RefObject<Element | null>, { margin }: { margin?: string } = {}) {
	const [inView, setInView] = useState(false);

	useEffect(() => {
		const element = ref.current;
		if (!element || inView) return;

		const observer = new IntersectionObserver(
			([entry]) => {
				if (entry?.isIntersecting) setInView(true);
			},
			margin ? { rootMargin: margin } : undefined,
		);
		observer.observe(element);
		return () => observer.disconnect();
	}, [ref, margin, inView]);

	return inView;
}
